import moment from "moment";
const newYearString = () => {
    return moment().format("YYYY");
};
const newDateString = () => {
    return moment().format("YYYY-MM-DD");
};
const newTimeString = () => {
    return moment().format("YYYY-MM-DD HH:mm");
};
const fromServerDate = (date) => {
    return {
        toDateString() {
            return moment(date).format("YYYY-MM-DD");
        },
        toUtcDateString() {
            return moment(date).utc().format("YYYY-MM-DD");
        },
    };
};
const fromDateString = (date) => {
    return {
        getMonth() {
            return moment(date).month() + 1;
        },
        getYear() {
            return moment(date).year();
        },
        add: {
            months(count = 1) {
                return moment(date).add(count, "month").format("YYYY-MM-DD");
            },
        },
        subtract: {
            months(count = 1) {
                return moment(date).subtract(count, "month").format("YYYY-MM-DD");
            },
        },
        format: {
            toMonthYearText: moment(date).format("MMMM, YYYY"),
        },
        shift: {
            toStartOfdayUtc: moment(date).utc(true).startOf("day").toISOString(),
            toEndOfUtcDay: moment(date).utc(true).endOf("day").toISOString(),
        },
    };
};
const validate = (date) => {
    return {
        isValidDateTime: () => {
            return moment(date, "YYYY-MM-DD", true).isValid();
        },
    };
};
export default {
    validate,
    newYearString,
    newDateString,
    newTimeString,
    fromDateString,
    fromServerDate,
};
